import { Pipe, PipeTransform, Inject, PLATFORM_ID } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { isPlatformBrowser } from '@angular/common';
import DOMPurify from 'dompurify';

@Pipe({ name: 'safeHtml' })
export class SafeHtmlPipe implements PipeTransform {
  private purifier: any | null = null;

  constructor(private sanitizer: DomSanitizer, @Inject(PLATFORM_ID) private platformId: Object) {
    if (isPlatformBrowser(this.platformId)) {
      this.purifier = DOMPurify;
    }
  }

  transform(value: string | null | undefined, config?: any): SafeHtml {
    if (!value) return '';

    // Initial sanitize, allow internal 'companyportal:' scheme so hrefs are preserved.
    const companyRegexp = /^(?:https?:|mailto:|tel:|companyportal:|#|\/)/i;
    const mergedConfig = Object.assign({}, config || {}, {
      ALLOWED_URI_REGEXP: (config && config.ALLOWED_URI_REGEXP) ? config.ALLOWED_URI_REGEXP : companyRegexp
    });
    const sanitized = this.purifier.sanitize(value, mergedConfig || {});

    // Ensure anchor tags open in a new tab and use noopener noreferrer
    const wrapper = document.createElement('div');
    wrapper.innerHTML = sanitized as string;
    const anchors = wrapper.querySelectorAll('a');

    anchors.forEach(a => {
      const href = (a.getAttribute('href') || '').trim();

      if (href.startsWith('companyportal:')) {
        return;
      }

      if (!a.getAttribute('target')) a.setAttribute('target', '_blank');
      const rel = (a.getAttribute('rel') || '').split(' ').filter(Boolean);
      if (!rel.includes('noopener')) rel.push('noopener');
      if (!rel.includes('noreferrer')) rel.push('noreferrer');
      a.setAttribute('rel', rel.join(' '));
    });

    const finalHtml = wrapper.innerHTML;

    return this.sanitizer.bypassSecurityTrustHtml(finalHtml);
  }
}
